import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'
import type { TPropertyId, TRegionId } from 'stores/fieldAssetStore/helperTypes'
import { selectedFieldAssetsStore } from 'stores/selectedFieldAssetsStore/selectedFieldAssetsStore'

export const getTimezoneForSelectedPropertyOrRegion = (
  {
    properties,
    propertyId,
    regions,
    regionId,
  }: {
    properties?: ReturnType<typeof fieldAssetStore.getState>['properties']
    propertyId?: TPropertyId | null
    regions?: ReturnType<typeof fieldAssetStore.getState>['regions']
    regionId?: TRegionId | null
  } = {
    properties: fieldAssetStore.getState().properties,
    propertyId: selectedFieldAssetsStore.getState().property,
    regions: fieldAssetStore.getState().regions,
    regionId: selectedFieldAssetsStore.getState().region,
  },
) => {
  return (
    properties?.[propertyId as number]?.timezone ??
    regions?.[regionId as string]?.timezone ??
    'America/Los_Angeles'
  )
}
